import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { finalize, takeUntil } from 'rxjs/operators';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { UnitType } from '../../../../../models/enums/unit-type.enum';
import { IceapiService } from '../../../../../services';
import { MeasurementService } from '../../../../../services/measurement.service';
import { AdditionalThicknessModel } from '../../../models';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-additional-component',
    templateUrl: './additional-component.component.html',
    styleUrls: ['./additional-component.component.scss'],
})
export class AdditionalComponentComponent implements OnInit, OnDestroy {
    @Input() form: UntypedFormGroup;
    @Input()
    set pressureClassId(value: string) {
        if (value) {
            this._pressureClassId = value;
            this.getAdditionalThicknesses();
        }
    }
    get pressureClassId(): string {
        return this._pressureClassId;
    }

    @Input()
    set pipeSizeId(value: string) {
        if (value) {
            this._pipeSizeId = value;
            this.getAdditionalThicknesses();
        }
    }
    get pipeSizeId(): string {
        return this._pipeSizeId;
    }

    destroy$ = new Subject();

    tooltip_position = 'above';
    loading: boolean = false;
    additionalThicknessList: AdditionalThicknessModel[];
    private _pressureClassId: string;
    private _pipeSizeId: string;

    constructor(
        private iceapi: IceapiService,
        private measSvc: MeasurementService,
        private user_utility: UserUtilityService
    ) {}

    ngOnInit(): void {
        this.form
            .get('addnlOverideValue')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => this.form.get('addnlOverideValue').patchValue(this.measSvc.format(value, UnitType.DefaultLengthUnit)));
    }

    getAdditionalThicknesses(): void {
        if (this.pressureClassId !== undefined && this.pipeSizeId !== undefined) {
            this.loading = true;

            this.iceapi
                .getAdditionalThicknesses(this.pressureClassId, this.pipeSizeId)
                .pipe(
                    finalize(() => {
                        this.loading = false;
                    })
                )
                .pipe(takeUntil(this.destroy$))
                .subscribe((addnlThicknesses) => {
                    if (addnlThicknesses.success === true) {
                        this.additionalThicknessList = addnlThicknesses.response;
                    } else {
                        this.user_utility.errorModelPopup(addnlThicknesses.message);
                    }
                });
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
